import { FileUploadService, FileUploadResult, UploadLimitsLocal } from "../components/fileattachments.component";
import { Logger } from "../logging";
import { UploadLimits } from "../models/common.model";

declare const angular: any;
declare const language: any;

class ErrorDialogCtrl {
	/*@ngInject*/
	constructor(private $scope: ng.IScope, public $uibModalInstance: ng.ui.bootstrap.IModalServiceInstance, public header, public msg, public defaultStrings: IDefaultStrings, public language) {
		this.header = this.header || language.Generic.Common.kErrorMsgEmotional;
		this.msg = this.msg || language.Generic.Common.kUnexpErr;
		
	}

	close() {
		this.$uibModalInstance.close();
		this.$scope.$destroy();
	}
}

class MessageDialogCtrl {
	/*@ngInject*/
	constructor(private $scope: ng.IScope, public $uibModalInstance, public header, public msg, public defaultStrings: IDefaultStrings, public language) {
		this.header = this.header || language.Generic.Common.kAttention;
		this.msg = this.msg || language.Generic.ServAdmin.kNotice;
	}

	close() {
		this.$uibModalInstance.close();
		this.$scope.$destroy();
	}
}

class WaitDialogCtrl {
	public header: string;

	/*@ngInject*/
	constructor(
		private $scope: ng.IScope,
		private $uibModalInstance: ng.ui.bootstrap.IModalInstanceService,
		private $timeout: ng.ITimeoutService,
		public msg,
		public progress,
		public defaultStrings: IDefaultStrings,
		public language) {

		this.header = language.Generic.Movement.kPleaseWait;
		this.msg = this.msg || language.Generic.Common.kProcessing;
		this.progress = this.progress || 0;

		//#Listeners
		//#Note: used $timeout instead of $scope.$apply() because I was getting a $$nextSibling error

		//#close wait dialog
		$scope.$on('dialogs.wait.complete', () => {
			this.$timeout(() => {
				this.$uibModalInstance.close();
				this.$scope.$destroy();
			});
		});

		//#update the dialog's message
		$scope.$on('dialogs.wait.message', (evt, args) => {
			this.msg = args.msg || this.msg;
		});

		//#update the dialog's progress (bar) and/or message
		$scope.$on('dialogs.wait.progress', (evt, args) => {
			this.msg = args.msg || this.msg;
			this.progress = args.progress || this.progress;
		});

		new InfiniteProgress((progress) => {
			this.progress = progress;
			$scope.$applyAsync();
		});
	}

	getProgress() {
		return {
			width: this.progress + "%"
		}
	}
}

class ConfirmDialogCtrl {
	/*@ngInject*/
	constructor(private $uibModalInstance: ng.ui.bootstrap.IModalInstanceService, public header, public msg, public defaultStrings: IDefaultStrings, public language) {
		this.header = this.header || language.Generic.Common.kAttention;
		this.msg = this.msg || language.Generic.Common.kConfirmationRequired;
	}

	no() {
		this.$uibModalInstance.dismiss("no");
	}

	yes() {
		this.$uibModalInstance.close("yes");
	}

	close() {
		this.$uibModalInstance.dismiss();
	}
}

export interface IFileDialogOptions {
	//разрешенные расширения файлов (массив)
	fileExts?: (uploadLimits: UploadLimits) => string; // string
	//для сабмита формы
	url: string;
	//дополнительный параметры передаваемые в querystring
	queryStringParams?: any;
	//дополнительные параметры для сабмита
	submitData?: any | (() => any);
	//сообщение о разрешенных файловых расширений
	invalidFileExtMsg?: string;
	//максимальный размер файла, Кб
	maxFileSize?: number;
	// показывает описание файла
	withDescription?: boolean;
	// html-содержимое внутри окна
	contentHtml?: string;
	//функция определяющая необходимость ресайза изображения
	needResize?: (fileSize: number, uploadLimits: UploadLimits) => boolean;
	//максимальная ширина изображения
	maxWidth?: (uploadLimits: UploadLimits) => number;
	//качество
	quality?: (uploadLimits: UploadLimits) => number;
	// функция лимита вместо maxFileSize
	sizeLimit?: (uploadLimits: UploadLimits) => number;
	imageFile?: boolean;
	withPreview?: boolean;
	preUploadCheck?: () => boolean;
	//Изменение надписей
	overrideStrings?: IDefaultStrings;
	// Подсказка по ограничениям на файл
	hint?: boolean;
	//Сообщение ошибки
	hasError?: string;
}

class FileUploadDialogCtrl<T> {
	public files: any[];
	public fileUploadService: FileUploadService<T>;
	public withDescription?: boolean;

	/*@ngInject*/
	constructor(
		private $uibModalInstance: ng.ui.bootstrap.IModalInstanceService,
		private $sce: ng.ISCEService,
		private options: IFileDialogOptions,
		public header: string,
		public defaultStrings: IDefaultStrings,
		public language
	) {
		this.header = this.header || language.Generic.Common.kLoadFile;

		// todo: похоже на костыль нужно для отображения поля в директиве
		this.withDescription = this.options.withDescription;

		let limits: UploadLimitsLocal;
		if (this.options.maxFileSize) {
			limits = {
				fileSizeLimit: this.options.maxFileSize
			};
		}

		// * - в модулях, где используются IFileDialogOptions, значения захардкожены. В fileattachments.component - динамические.
		// Возможно, стоит также сделать их динамическими, но тогда нужно будет вводить новые константы в UploadLimits

		this.fileUploadService = new FileUploadService<T>(this.options.url, this.options.fileExts, limits, this.options.imageFile);
		this.fileUploadService.withPreview = this.options.withPreview;
		this.fileUploadService.sizeLimit = this.options.sizeLimit;
		this.fileUploadService.needResize = this.options.needResize;	// * 
		this.fileUploadService.maxWidth = this.options.maxWidth; // *
		this.fileUploadService.quality = this.options.quality; // *
		this.fileUploadService.hint = this.options.hint;

		this.fileUploadService.queryStringParams = this.options.queryStringParams;

		if (this.options.submitData) {
			if (typeof (this.options.submitData) == "function") {
				this.fileUploadService.getSubmitData = this.options.submitData;
			}
			else {
				this.fileUploadService.getSubmitData = () => this.options.submitData;
			}
		}

		if (this.options.overrideStrings) {
			angular.extend(defaultStrings, this.options.overrideStrings);
		}
	}

	checkContentHtml(): boolean {
		return !!this.options.contentHtml;
	}

	getContentHtml(): string {
		return this.$sce.trustAsHtml(this.options.contentHtml);
	}

	upload() {
		if (typeof this.options.preUploadCheck == "function") {
			if (!this.options.preUploadCheck()) {
				return;
			}
		}
		this.fileUploadService.submit()
			.then((uploadResult) => {
				this.$uibModalInstance.close(uploadResult);
			})
	}

	cancel() {
		this.$uibModalInstance.dismiss("cancel");
	}
}

const asPromise = (modalInstance): Promise<any> => {
	return new Promise((resolve, reject) => {
		modalInstance.result.then((data) => resolve(data), (data) => reject(data));
	})
}

export interface WaitHandle {
	close();
}

export class DialogsService {
	/*@ngInject*/
	constructor(private $uibModal: ng.ui.bootstrap.IModalService) {
	}

	error(msg: string, header?: string, isStatic?: boolean): Promise<any> {
		msg = this.replaceNewLineSymbol(msg);
		const settings = {
			templateUrl: '/dialogs/error.html',
			controller: ErrorDialogCtrl,
			controllerAs: "ctrl",
			backdrop: isStatic ? 'static' : true,
			keyboard: !isStatic,
			resolve: {
				header: () => angular.copy(header),
				msg: () => angular.copy(msg),
				language: () => angular.copy(language)
			}
		}

		const modalInstance = this.$uibModal.open(settings);

		return asPromise(modalInstance);
	}

	wait(msg: string, progress?): WaitHandle {
		msg = this.replaceNewLineSymbol(msg);
		const settings = {
			templateUrl: '/dialogs/wait.html',
			controller: WaitDialogCtrl,
			controllerAs: "ctrl",
			backdrop: 'static',
			keyboard: false,
			resolve: {
				progress: () => angular.copy(progress),
				msg: () => angular.copy(msg),
				language: () => angular.copy(language)
			}
		}

		const modalInstance = this.$uibModal.open(settings);
		return {
			close: () => modalInstance.close()
		}
	}

	warning(msg: string, header?: string, options?: any) {
		msg = this.replaceNewLineSymbol(msg);
		const defaultSettings = {
			templateUrl: '/dialogs/warning.html',
			controller: MessageDialogCtrl,
			controllerAs: "ctrl",
			backdrop: true,
			keyboard: true,
			resolve: {
				header: () => angular.copy(header || language.Generic.Common.kAttention),
				msg: () => angular.copy(msg),
				language: () => angular.copy(language)
			}
		}

		let settings = Object.assign({}, defaultSettings, options);
		const modalInstance = this.$uibModal.open(settings);

		return asPromise(modalInstance);
	}

	message(msg: string, header?: string, options?: any): Promise<any> {
		msg = this.replaceNewLineSymbol(msg);
		const defaultSettings = {
			templateUrl: '/dialogs/notify.html',
			controller: MessageDialogCtrl,
			controllerAs: "ctrl",
			backdrop: true,
			keyboard: true,
			resolve: {
				header: () => angular.copy(header || language.Generic.Common.kAttention),
				msg: () => angular.copy(msg),
				language: () => angular.copy(language)
			}
		}

		let settings = Object.assign({}, defaultSettings, options);
		const modalInstance = this.$uibModal.open(settings);

		return asPromise(modalInstance);
	}

	notify(header, msg, isStatic) {
		msg = this.replaceNewLineSymbol(msg);
		const settings = {
			templateUrl: '/dialogs/notify.html',
			controller: MessageDialogCtrl,
			controllerAs: "ctrl",
			backdrop: isStatic ? 'static' : true,
			keyboard: !isStatic,
			resolve: {
				header: () => angular.copy(header),
				msg: () => angular.copy(msg),
				language: () => angular.copy(language)
			}
		}

		const modalInstance = this.$uibModal.open(settings);

		return modalInstance.result;
	}

	confirm(msg: string, header?: string, isStatic?: boolean): Promise<any> {
		msg = this.replaceNewLineSymbol(msg);
		const settings = {
			templateUrl: '/dialogs/confirm.html',
			controller: ConfirmDialogCtrl,
			controllerAs: "ctrl",
			backdrop: isStatic ? 'static' : true,
			keyboard: !isStatic,
			resolve: {
				header: () => angular.copy(header),
				msg: () => angular.copy(msg),
				language: () => angular.copy(language)
			}
		}

		const modalInstance = this.$uibModal.open(settings);

		return asPromise(modalInstance);
	}

	confirmDelete(msg: string, header?: string, isStatic?: boolean): Promise<any> {
		msg = this.replaceNewLineSymbol(msg);
		const settings = {
			templateUrl: '/dialogs/confirmDelete.html',
			controller: ConfirmDialogCtrl,
			controllerAs: "ctrl",
			backdrop: isStatic ? 'static' : true,
			keyboard: !isStatic,
			resolve: {
				header: () => angular.copy(header),
				msg: () => angular.copy(msg),
				language: () => language
			}
		}

		const modalInstance = this.$uibModal.open(settings);

		return asPromise(modalInstance);
	}

	uploadFile<T>(header: string, options: IFileDialogOptions, isStatic?: boolean): Promise<FileUploadResult<T>> {
		const settings = {
			templateUrl: '/dialogs/upload.html',
			controller: FileUploadDialogCtrl,
			controllerAs: "ctrl",
			backdrop: isStatic ? 'static' : true,
			keyboard: !isStatic,
			resolve: {
				header: () => angular.copy(header),
				options: () => options,
				language: () => language
			}
		}

		const modalInstance = this.$uibModal.open(settings);

		return asPromise(modalInstance);
	}

	create(url, ctrlr, data, opts) {
		opts = opts || {}
		const k = opts.keyboard || true
		const b = opts.backdrop || true
		const w = opts.windowClass || 'dialogs-default'

		const settings = {
			templateUrl: url,
			controller: ctrlr,
			backdrop: b,
			keyboard: k,
			windowClass: w,
			resolve: {
				data: () => angular.copy(data),
			}
		}

		const modalInstance = this.$uibModal.open(settings);

		return modalInstance.result;
	}

	public translate(newStrings) {
		angular.extend(defaultStrings, newStrings);
	}

	public getDefaultStrings() {
		return defaultStrings;
	}

	private replaceNewLineSymbol(str) {
		return str.split("\\n").join('<br/>');
	}
}

interface IDefaultStrings {
	error?: string,
	errorMessage?: string,
	close?: string,
	pleaseWait?: string,
	processing?: string,
	pleaseWaitEllipsis?: string,
	pleaseWaitMessage?: string,
	percentComplete?: string,
	message?: string,
	notification?: string,
	notificationMessage?: string,
	confirmation?: string,
	confirmationMessage?: string,
	ok?: string,
	cancel?: string,
	yes?: string,
	no?: string,
}

var defaultStrings: IDefaultStrings = {
	error: language.Generic.Common.kErrorMsgEmotional,
	errorMessage: language.Generic.Common.kUnexpErr,
	close: language.Generic.Buttons.kClose,
	pleaseWait: language.Generic.Curriculum.kPleaseWait,
	processing: language.Generic.Common.kProcessing,
	pleaseWaitEllipsis: language.Generic.Movement.kPleaseWait,
	pleaseWaitMessage: "Waiting on operation to complete.",
	percentComplete: language.Generic.Common.kPercentCompleted,
	message: language.Generic.Common.kAttention,
	notification: language.Generic.ServAdmin.kNotice,
	notificationMessage: language.Generic.Common.kUnknownNotification,
	confirmation: language.Generic.Common.kAttention,
	confirmationMessage: language.Generic.Common.kConfirmationRequired,
	ok: language.Generic.Common.kOk,
	cancel: language.Generic.Buttons.kCancel,
	yes: language.Generic.Common.kYes,
	no: language.Generic.Common.kNo
};

class ShowerModalDialogService {
	private wait: WaitHandle = null;
	private counter: number = 0;

	/*@ngInject*/
	constructor(private $dialogs: DialogsService, private $timeout) {
	}

	show(message?: string, header?: string): WaitHandle {
		if (this.counter == 0 && !this.wait) {
			this.wait = this.$dialogs.wait(message || language.Generic.Common.kProcessing);
		}
		this.counter++;
		return {
			close: () => this.close()
		};
	}

	get isShowing() {
		return this.counter > 0;
	}

	close() {
		if (this.counter > 0) {
			this.counter--;
		}

		this.$timeout(() => {
			if (this.counter == 0 && this.wait) {
				this.wait.close();
				this.wait = null;
			}
		}, 100);
	}
}

export class LongWorkService extends ShowerModalDialogService {
	execute<T>(work: Promise<T> | ng.IPromise<T>, message?: string): Promise<T> {
		this.show();

		work.finally(() => {
			this.close();
		});

		return <Promise<T>>work;
	}
}

const InfiniteProgressBarComponent = {
	selector: "infiniteProgressBar",
	controller: class ProgressBarController {
		public progress: number;
		public percentComplete: string = language.Generic.Common.kPercentCompleted2;

		/*@ngInject*/
		constructor(private $scope: ng.IScope) {
		}

		$onInit() {
			new InfiniteProgress((progress) => {
				this.progress = progress;
				this.$scope.$applyAsync();
			});
		}

		public getProgress() {
			return {
				width: this.progress + "%"
			}
		}
	},
	controllerAs: "$ctrl",
	template: `<div class="progress progress-striped active">
					<div class="progress-bar progress-bar-info" ng-style="$ctrl.getProgress()"></div>
					<span class="sr-only">{{$ctrl.progress | number:2}}{{$ctrl.percentComplete}}</span>
				</div>`
}

class InfiniteProgress {
	private current: number = 0;
	private timer: any;

	constructor(
		private setCallBack: (progress: number) => void
	) {

		window.setTimeout(() => {
			this.timer = window.setInterval(() => {
				this.current = this.getNext();
				this.setCallBack(this.current);
			}, 100);
		}, 200);
	}

	getIncr(current: number) {

		if (current >= 1) {
			window.clearInterval(this.timer);
			return 0;
		}
		let rnd = 0;

		if (current >= 0 && current < 0.25)
			rnd = (Math.random() * (5 - 3 + 1) + 3) / 100		// Start out between 3 - 6% increments
		else if (current >= 0.25 && current < 0.65)
			rnd = (Math.random() * 3) / 100						// increment between 0 - 3%
		else if (current >= 0.65 && current < 0.9)
			rnd = Math.random() / 100							// increment between 0 - 1%
		else if (current >= 0.9 && current < 0.99)
			rnd = 0.001											// finally, increment it .1 %
		else {
			window.clearInterval(this.timer); // after 99%, don't increment:
			return 0;
		}

		return rnd;
	}

	getNext(): number {
		let incr = this.getIncr(this.current / 100) * 100 * 2;
		return this.current + incr;
	}

}

angular.module('uikit.dialogs.services', ['ui.bootstrap', 'ui.bootstrap.modal'])
	.component(InfiniteProgressBarComponent.selector, InfiniteProgressBarComponent)
	.service('$dialogs', DialogsService)
	.service("$showerModalDialog", ShowerModalDialogService)
	.service("$longWork", LongWorkService);

angular.module('uikit.dialogs', ['ui.bootstrap', 'ui.bootstrap.modal', 'uikit.dialogs.services', 'ngSanitize'])
	.value("defaultStrings", defaultStrings)
	.value("language", language)

	.run(['$templateCache', '$interpolate', ($templateCache, $interpolate) => {
		const startSym = $interpolate.startSymbol();
		const endSym = $interpolate.endSymbol();

		$templateCache.put('/dialogs/error.html',
			`<div class="bootstrap-dialog type-danger">
				<div class="modal-header">
					<div class="bootstrap-dialog-header">
						<div class="bootstrap-dialog-close-button" style="display: block;">
							<button class="close" ng-click="ctrl.close()">×</button>
						</div>
						<div class="bootstrap-dialog-title"></span> ` + startSym + `ctrl.header` + endSym + `</div>
					</div>
				</div>
				<div class="modal-body">
					<div class="bootstrap-dialog-body">
						<div class="bootstrap-dialog-message">
							<div class="wrap-pre" ng-bind-html="ctrl.msg"></div>
						</div>
					</div>
				</div>
				<div class="modal-footer">
					<div class="bootstrap-dialog-footer">
						<div class="bootstrap-dialog-footer-buttons">
							<button type="button" class="btn btn-default" ng-click="ctrl.close()">
								<span class="bootstrap-dialog-button-icon glyphicon glyphicon-ok-sign"></span>
								` + startSym + `ctrl.language.Generic.Common.kOk` + endSym +
			`</button>
						</div>
					</div>
				</div>
			</div>`);

		$templateCache.put('/dialogs/warning.html',
			`<div class="bootstrap-dialog type-warning">
			<div class="modal-header">
				<div class="bootstrap-dialog-header">
					<div class="bootstrap-dialog-close-button">
						<button class="close" ng-click="ctrl.close()">&times;</button>
					</div>
					<div class="bootstrap-dialog-title"><span class="glyphicon glyphicon-info-sign"></span> ` + startSym + `ctrl.header` + endSym + `</div>
				</div>
			</div>
			<div class="modal-body">
				<div class="bootstrap-dialog-body">
					<div style="overflow-y: auto; max-height: 400px" class="bootstrap-dialog-message">
						<div class="wrap-pre" ng-bind-html="ctrl.msg"></div>
					</div>
				</div>
			</div>
			<div class="modal-footer">
				<div class="bootstrap-dialog-footer">
					<div class="bootstrap-dialog-footer-buttons">
						<button type="button" class="btn btn-default" ng-click="ctrl.close()">
							<span class="bootstrap-dialog-button-icon glyphicon glyphicon-ok-sign"></span> ` + startSym + `ctrl.language.Generic.Common.kOk` + endSym + `
						</button>
					</div>
				</div>
			</div>
		</div>`)

		$templateCache.put('/dialogs/notify.html',
			`<div class="bootstrap-dialog type-info">
				<div class="modal-header">
					<div class="bootstrap-dialog-header">
						<div class="bootstrap-dialog-close-button">
							<button class="close" ng-click="ctrl.close()">&times;</button>
						</div>
						<div class="bootstrap-dialog-title"><span class="glyphicon glyphicon-info-sign"></span> ` + startSym + `ctrl.header` + endSym + `</div>
					</div>
				</div>
				<div class="modal-body">
					<div class="bootstrap-dialog-body">
						<div class="bootstrap-dialog-message">
							<div class="wrap-pre" ng-bind-html="ctrl.msg"></div>
						</div>
					</div>
				</div>
				<div class="modal-footer">
					<div class="bootstrap-dialog-footer">
						<div class="bootstrap-dialog-footer-buttons">
							<button type="button" class="btn btn-default" ng-click="ctrl.close()">
								<span class="bootstrap-dialog-button-icon glyphicon glyphicon-ok-sign"></span> ` + startSym + `ctrl.language.Generic.Common.kOk` + endSym + `
							</button>
						</div>
					</div>
				</div>
			</div>`);

		$templateCache.put('/dialogs/wait.html',
			`<div class="bootstrap-dialog type-primary">
				<div class="modal-header">
					<div class="bootstrap-dialog-header">
						<div class="bootstrap-dialog-title"> <span class="glyphicon glyphicon-time"></span> ` + startSym + `ctrl.header` + endSym + `</div>
					</div>
				</div>
				<div class="modal-body">
					<div class="bootstrap-dialog-body">
						<div class="bootstrap-dialog-message">
							<p ng-bind-html="ctrl.msg"></p>
							<infinite-progress-bar></infinite-progress-bar>
						</div>
					</div>
				</div>
			</div>`);

		$templateCache.put('/dialogs/confirm.html',
			`<div class="bootstrap-dialog type-primary">
				<div class="modal-header">
					<div class="bootstrap-dialog-header">
						<div class="bootstrap-dialog-close-button" style="display: block;">
							<button class="close" ng-click="ctrl.close()">&times;</button>
						</div>
						<div class="bootstrap-dialog-title"> ` + startSym + `ctrl.header` + endSym + `</div>
					</div>
				</div>
				<div class="modal-body">
					<div class="bootstrap-dialog-body">
						<div class="bootstrap-dialog-message">
							<div class="wrap-pre" ng-bind-html="ctrl.msg"></div>
						</div>
					</div>
				</div>
				<div class="modal-footer">
					<div class="bootstrap-dialog-footer">
						<div class="bootstrap-dialog-footer-buttons">
							<button class="btn btn-primary" autofocus ng-click="ctrl.yes()">
								<span class="bootstrap-dialog-button-icon glyphicon glyphicon-ok-sign"></span>
								` + startSym + 'ctrl.language.Generic.Common.kYes' + endSym + `
							</button>
							<button class="btn btn-default" ng-click="ctrl.no()">
								<span class="bootstrap-dialog-button-icon glyphicon glyphicon-remove-sign"></span>
								` + startSym + 'ctrl.language.Generic.Common.kNo' + endSym + `
							</button>
						</div>
					</div>
				</div>
			</div>`);

		$templateCache.put('/dialogs/confirmDelete.html',
			`<div class="bootstrap-dialog type-danger">
				<div class="modal-header">
					<div class="bootstrap-dialog-header">
						<div class="bootstrap-dialog-close-button">
							<button class="close" ng-click="ctrl.no()">&times;</button>
						</div>
						<div class="bootstrap-dialog-title"> ` + startSym + `ctrl.header` + endSym + `</div>
					</div>
				</div>
				<div class="modal-body">
					<div class="bootstrap-dialog-body">
						<div class="bootstrap-dialog-message">
							<div class="wrap-pre" ng-bind-html="ctrl.msg"></div>
						</div>
					</div>
				</div>
				<div class="modal-footer">
					<div class="bootstrap-dialog-footer">
						<div class="bootstrap-dialog-footer-buttons">
							<button class="btn btn-danger" ng-click="ctrl.yes()">
								<span class="bootstrap-dialog-button-icon glyphicon glyphicon-ok-sign"></span>
								` + startSym + 'ctrl.language.Generic.Common.kYes' + endSym + `
							</button>
							<button class="btn btn-default" ng-click="ctrl.no()">
								<span class="bootstrap-dialog-button-icon glyphicon glyphicon-remove-sign"></span>
								` + startSym + 'ctrl.language.Generic.Common.kNo' + endSym + `
							</button>
						</div>
					</div>
				</div>
			</div>`);


		$templateCache.put('/dialogs/upload.html',
			`<div class="bootstrap-dialog type-primary">
				<div class="modal-header">
					<div class="bootstrap-dialog-header">
						<div class="bootstrap-dialog-close-button">
							<button class="close" ng-click="ctrl.cancel()">&times;</button>
						</div>
						<div class="bootstrap-dialog-title"> ` + startSym + `ctrl.header` + endSym + `</div>
					</div>
				</div>
				<div class="modal-body">
					<div class="bootstrap-dialog-body">
						<div ng-if="ctrl.checkContentHtml()" ng-bind-html="ctrl.getContentHtml()"></div>
						<div class="form-group">
							<file-upload service="ctrl.fileUploadService" with-description="ctrl.withDescription"></file-upload>
						</div>
					</div>
				</div>
				<div class="modal-footer">
					<div class="bootstrap-dialog-footer">
						<div class="bootstrap-dialog-footer-buttons">
							<button class="btn btn-primary" ng-click="ctrl.upload()">
								<span class="bootstrap-dialog-button-icon glyphicon glyphicon-ok-sign"></span>
								` + startSym + `ctrl.defaultStrings.ok` + endSym + `
							</button>
							<button class="btn btn-default" ng-click="ctrl.cancel()">
								<span class="bootstrap-dialog-button-icon glyphicon glyphicon-ban-circle"></span>
								` + startSym + `ctrl.defaultStrings.cancel` + endSym + `
							</button>
						</div>
					</div>
				</div>
			</div>`);
	}]);
